/**
 * P3-31: Praise 按钮。
 */
import { useCallback, type MouseEvent } from "react";
import { GameButton } from "../../components/GameButton";
import { usePraiseButtonModel } from "./useReligionModel";
import { t } from "../../bridge/i18n";

interface PraiseButtonProps {
  handler: () => void;
}

export function PraiseButton({ handler }: PraiseButtonProps) {
  const { snap, modelRef, controller, getTooltip } = usePraiseButtonModel(
    t("religion.praiseBtn.label"),
    t("religion.praiseBtn.desc"),
    handler,
  );

  const onClick = useCallback(
    (event: MouseEvent) => {
      if (controller && modelRef.current) {
        controller.buyItem?.(modelRef.current, event);
      }
    },
    [controller, modelRef],
  );

  if (!snap || !snap.visible) {
    return null;
  }

  return (
    <GameButton
      name={snap.name}
      description={snap.description}
      enabled={snap.enabled}
      resourceIsLimited={snap.resourceIsLimited}
      getTooltip={getTooltip}
      onClick={onClick}
    />
  );
}
